// Normalization is called for every row and every keystroke of the list filters and tree searches: results
// are cached (bounded) because the same labels are normalized over and over.
const NORMALIZED_CACHE_MAX_SIZE = 20000
const normalizedCache = new Map<string, string>()

export const normalizeString = (str: string) => {
  let normalized = normalizedCache.get(str)
  if (normalized === undefined) {
    normalized = str
      .toLowerCase()
      .trim()
      .replace(",", ".")
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "")
    if (normalizedCache.size >= NORMALIZED_CACHE_MAX_SIZE) {
      normalizedCache.clear()
    }
    normalizedCache.set(str, normalized)
  }
  return normalized
}
